module.exports = __webpack_public_path__ + "img/juheshang.99f00b30.png";